import keyMirror from "key-mirror";

export const TABLE_DATA_TYPES = keyMirror({
    NUMBER: null,
    DATE: null,
    DAYS: null,
    CURRENCY: null,
    STRING: null,
    ENUM: null,
    BOOLEAN: null,
    OPTIONS: null,
    SELECT: null
});
